import axios from "axios";


export async function FetchShopDetails() {
  const url = process.env.REACT_APP_API_URL;
 
  try {
    const response = await axios.get(`${url}/api/products`);

    console.log("response product", response.data.data);
    return response.data.data;
  } catch (error) {
    throw new Error("Error fetching shop details:", error);
  }
}
